import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { Marcas } from 'service/api'

export const useMemoMarcas = () => {
    const { watch } = useFormContext()

    const selectConexao = watch('tipoConexao', true)
    const marca = watch('marcaId', true) as Marcas

    return useMemo(() => {
        switch (marca) {
            case Marcas.NULL:
                return {
                    disabled: {
                        numeroSerie: true,
                        ultimoNsr: true,
                        usuario: true,
                        senha: true,
                        tipoConexao: true,
                        ip: true,
                        porta: true,
                        dataInicial: true,
                    },
                    required: {
                        numeroSerie: false,
                        ultimoNsr: false,
                        usuario: false,
                        senha: false,
                        tipoConexao: false,
                        ip: false,
                        porta: false,
                        dataInicial: false,
                    },
                }
            case Marcas.GERTEC_G3:
                return {
                    disabled: {
                        numeroSerie: false,
                        ultimoNsr: false,
                        usuario: true,
                        senha: false,
                        tipoConexao: true,
                        ip: false,
                        porta: true,
                        dataInicial: false,
                    },
                    required: {
                        numeroSerie: true,
                        ultimoNsr: true,
                        usuario: false,
                        senha: true,
                        tipoConexao: false,
                        ip: true,
                        porta: false,
                        dataInicial: false,
                    },
                }
            case Marcas.GERTEC_G1_G2:
                return {
                    disabled: {
                        numeroSerie: false,
                        ultimoNsr: false,
                        usuario: true,
                        senha: true,
                        tipoConexao: true,
                        ip: false,
                        porta: true,
                        dataInicial: false,
                    },
                    required: {
                        numeroSerie: true,
                        ultimoNsr: true,
                        usuario: false,
                        senha: false,
                        tipoConexao: false,
                        ip: true,
                        porta: false,
                        dataInicial: false,
                    },
                }

            case Marcas.REP_TERMINAL:
                return {
                    disabled: {
                        numeroSerie: true,
                        ultimoNsr: true,
                        usuario: true,
                        senha: true,
                        tipoConexao: true,
                        ip: true,
                        porta: true,
                        dataInicial: false,
                    },
                    required: {
                        numeroSerie: false,
                        ultimoNsr: false,
                        usuario: false,
                        senha: false,
                        tipoConexao: false,
                        ip: false,
                        porta: false,
                        dataInicial: false,
                    },
                }

            case Marcas.CONTROLID:
                return {
                    disabled: {
                        numeroSerie: false,
                        ultimoNsr: false,
                        usuario: false,
                        senha: false,
                        tipoConexao: true,
                        ip: false,
                        porta: false,
                        dataInicial: false,
                    },
                    required: {
                        numeroSerie: true,
                        ultimoNsr: false,
                        usuario: false,
                        senha: false,
                        tipoConexao: false,
                        ip: true,
                        porta: false,
                        dataInicial: false,
                    },
                }

            case Marcas.TOP_DATA:
                return {
                    disabled: {
                        numeroSerie: false,
                        ultimoNsr: false,
                        usuario: true,
                        senha: true,
                        tipoConexao: true,
                        ip: false,
                        porta: false,
                        dataInicial: false,
                    },
                    required: {
                        numeroSerie: true,
                        ultimoNsr: false,
                        usuario: false,
                        senha: false,
                        tipoConexao: false,
                        ip: true,
                        porta: false,
                        dataInicial: false,
                    },
                }

            default:
                return {
                    disabled: {
                        numeroSerie: false,
                        ultimoNsr: false,
                        usuario: false,
                        senha: false,
                        tipoConexao: false,
                        ip: false,
                        porta: false,
                        dataInicial: false,
                    },
                    required: {
                        numeroSerie: false,
                        ultimoNsr: false,
                        usuario: false,
                        senha: false,
                        tipoConexao: false,
                        ip: false,
                        porta: false,
                        dataInicial: false,
                    },
                }
        }
    }, [marca, selectConexao])
}
